// extracted by mini-css-extract-plugin
export var cardTitle = "_hc-1";
export var commentBubble = "_hc-e";
export var commentForm = "_hc-a";
export var commentInput = "_hc-b";
export var commentLabel = "_hc-d";
export var commentPrompt = "_hc-9";
export var csatCard = "_hc-0";
export var feedbackSection = "_hc-7";
export var starDisabled = "_hc-6";
export var starEmpty = "_hc-5";
export var starFilled = "_hc-4";
export var starWrapper = "_hc-3";
export var starsContainer = "_hc-2";
export var submittedComment = "_hc-c";
export var thankYouText = "_hc-8";